import { NgModule } from '@angular/core';
import { EventPropagationFixDirective } from './event-propagation-fix.directive';
import { MatSelectFixDirective } from './mat-select-fix.directive';

@NgModule({
    imports: [
        
    ],
    declarations:[
        EventPropagationFixDirective,
        MatSelectFixDirective
    ],
    exports:[
        EventPropagationFixDirective,
        MatSelectFixDirective
    ]
})
export class SharedDirectiveModule { }